import React from "react";
import Slider from "react-slick";
import Tooltip from "@material-ui/core/Tooltip";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import { withStyles } from "@material-ui/core/styles";
import Zoom from "@material-ui/core/Zoom";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../Config/axiosInstance";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "red",
    // color: "#FFFFFF",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    marginBottom: "0px",
  },
}))(Tooltip);

const zoomInAnimation = keyframes`${zoomIn}`;

const ZoomInDiv = styled.div`
  animation: 1s ${zoomInAnimation};
`;

function NewlyAddedStores() {
  const { newlyAddedStores } = useSelector((state) => state.Stores);

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <div className="carousel pb-4">
      <Container>
        {" "}
        <h5 className="Recommended">Newly Added Stores</h5>{" "}
      </Container>

      <Slider {...settings}>
        {/* {Array.map((ele) => (
          <div className="banner-carousel--item">{ele}</div>
        ))}  */}
        {newlyAddedStores.slice(5, 10).map((store, key) => (
          <ZoomInDiv className="card" key={key}>
            <Link to={`/store/${store.slug}`}>
              <LightTooltip
                placement="top"
                interactive
                TransitionComponent={Zoom}
              >
                <>
                  <img
                    src={`${BASE_URL}/${store?.image}`}
                    alt="store"
                    height="100"
                    width="120"
                    style={{ objectFit: "contain" }}
                  />
                </>
              </LightTooltip>
            </Link>
          </ZoomInDiv>
        ))}

        <Link to="/lateststore">
          <ZoomInDiv className="card showmore">
            <p>
              <b>{newlyAddedStores.length}</b>
              <br />
              <b>Stores &gt;&gt;</b>
            </p>{" "}
          </ZoomInDiv>
        </Link>
      </Slider>
    </div>
  );
}

export default NewlyAddedStores;
